import { useForm } from "react-hook-form";
import { useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useFormStore } from "../components/store/formStore";
export function useSectionForm(schema, sectionName, defaultValues) {
    const { control, formState: { errors, dirtyFields, isValid }, trigger, getValues, reset, setValue, watch, setFocus, handleSubmit, unregister, } = useForm({
        resolver: zodResolver(schema),
        mode: "onSubmit",
        reValidateMode: "onChange",
        defaultValues,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { editingSection } = useFormStore();
    const isBlocked = editingSection !== null && editingSection !== sectionName;
    const handleFormSubmit = async (onSubmit) => {
        try {
            const isValid = await trigger();
            if (!isValid) {
                handleSubmit(() => { })();
                return;
            }
            setIsSubmitting(true);
            const formData = getValues();
            await onSubmit(formData);
            reset(formData, {
                keepValues: true,
                keepDirtyValues: false,
            });
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return {
        control,
        errors,
        isDirty: Object.keys(dirtyFields).length > 0,
        isSubmitting,
        isBlocked,
        handleSubmit: handleFormSubmit,
        formState: { errors },
        reset,
        setValue,
        getValues,
        watch,
        isValid,
        setFocus,
        unregister,
    };
}
//# sourceMappingURL=useSectionForm.js.map